import React, { useState } from 'react';
import { Linking, Platform, Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Toast from 'react-native-toast-message';
import SolidButton from '@/components/General/SolidButton';
import { getFormEntryFileUrl } from '@/data/forms';
import { getFormFileError } from '@/utils/formFilePolicy';

const FormEntryFileButton = ({ file, testID }) => {
    const [processing, setProcessing] = useState(false);
    const filename = file?.filename || file?.path?.split('/').pop() || 'File';
    const blockedReason = getFormFileError({ ...file, filename });
    const download = async (event) => {
        event?.stopPropagation?.();
        if (processing) return;
        let tab;
        try {
            if (!file?.path) throw new Error('This file is unavailable.');
            if (blockedReason) throw new Error(blockedReason);
            if (Platform.OS === 'web') {
                tab = window.open('', '_blank');
                if (!tab) throw new Error('Allow pop-ups to download this file, then try again.');
                tab.opener = null;
            }
            setProcessing(true);
            const url = await getFormEntryFileUrl({ path: file.path, filename });
            if (tab) tab.location.replace(url);
            else await Linking.openURL(url);
        } catch (error) {
            tab?.close();
            Toast.show({ type: 'error', text2: error.message || 'Unable to download this file. Try again.' });
        } finally {
            setProcessing(false);
        }
    };
    return (
        <SolidButton
            text={`Download ${filename}`}
            onPress={download}
            processing={processing}
            variant="muted"
            type="forms"
            size="sm"
            iconName="download-outline"
            iconBefore
            tooltipText={blockedReason || filename}
            disabled={!!blockedReason}
            testID={testID}
        />
    );
};

const FormEntryFiles = ({ value, testID, emptyText = 'No file uploaded' }) => {
    const files = (Array.isArray(value) ? value : value ? [value] : []).filter(Boolean);
    return (
        <View style={styles.files}>
            {files.length ? files.map((file, index) => <FormEntryFileButton key={`${file.path || file.filename}-${index}`} file={file} testID={`${testID}-${index}`} />) : <Text style={styles.empty}>{emptyText}</Text>}
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts }) => ({
    files: { gap: 6, alignItems: 'flex-start' },
    empty: { color: colors.textSecondary, fontFamily: fonts.body, fontSize: 13 },
}));

export default FormEntryFiles;
